/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import React, { ReactElement } from 'react'
import chinaWallActive from '../assets/steps/china-wall-active.png'
import chinaWallInActive from '../assets/steps/china-wall.png'
import cyclingActive from '../assets/steps/cycling-active.png'
import cyclingInActive from '../assets/steps/cycling-inactive.png'
import dallasToDiegoInActive from '../assets/steps/dallas-san-diego.png'
import eiffelTowerActive from '../assets/steps/eiffel-tower-active.png'
import eiffelTowerInActive from '../assets/steps/eiffel-tower-inactive.png'
import globeActive from '../assets/steps/globe-active.png'
import globeSUSAInActive from '../assets/steps/globe-s-usa.png'
import globeInActive from '../assets/steps/globe.png'
import ironManActive from '../assets/steps/ironman-active.png'
import ironManInActive from '../assets/steps/ironman-inactive.png'
import { ReactComponent as KremlinIcon } from '../assets/steps/kremlin.svg'
import londonBridgeInActive from '../assets/steps/london-bridge.png'
import marathonActive from '../assets/steps/marathon-active.png'
import marathonInActive from '../assets/steps/marathon-inactive.png'
import moonActive from '../assets/steps/moon-active.png'
import moonInActive from '../assets/steps/moon.png'
import saharaActive from '../assets/steps/sahara-active.png'
import saharaInActive from '../assets/steps/sahara.png'
import { ReactComponent as LibertyIcon } from '../assets/steps/statue-of-liberty.svg'
import ultramarathonInActive from '../assets/steps/ultramarathon.png'

export interface StepsPathRank {
  name: string
  value: number
  renderIcon: (params: { isActive: boolean }) => ReactElement
}

const cssIcon = css`
  width: 20px;
  height: 20px;
  object-fit: contain;
`

const cssFillActivePaths = css`
  path {
    fill: #f9b22d;
  }
`

const ranks: StepsPathRank[] = [
  {
    name: 'Marathon',
    value: 42200,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={marathonActive} alt={'marathon'} css={cssIcon} />
      ) : (
        <img src={marathonInActive} alt={'marathon'} css={cssIcon} />
      ),
  },
  {
    name: 'Ultramarathon',
    value: 161000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={ultramarathonInActive} alt={'Ultramarathon'} css={cssIcon} />
      ) : (
        <img src={ultramarathonInActive} alt={'Ultramarathon'} css={cssIcon} />
      ),
  },
  {
    name: 'Dallas to San Antonio',
    value: 454000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={dallasToDiegoInActive} alt={''} css={cssIcon} />
      ) : (
        <img src={dallasToDiegoInActive} alt={''} css={cssIcon} />
      ),
  },
  {
    name: 'Edinburgh to London',
    value: 542000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={londonBridgeInActive} alt={''} css={cssIcon} />
      ) : (
        <img src={londonBridgeInActive} alt={''} css={cssIcon} />
      ),
  },
  // {
  //   name: 'Ironman',
  //   value: 226200,
  //   renderIcon: ({ isActive }) =>
  //     isActive ? (
  //       <img src={ironManActive} alt={'ironman'} css={cssIcon} />
  //     ) : (
  //       <img src={ironManInActive} alt={'ironman'} css={cssIcon} />
  //     ),
  // },
  {
    name: 'Paris to Berlin',
    value: 990000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={eiffelTowerActive} alt={'eiffel'} css={cssIcon} />
      ) : (
        <img src={eiffelTowerInActive} alt={'eiffel'} css={cssIcon} />
      ),
  },
  {
    name: 'Across the Sahara desert',
    value: 1609000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={saharaActive} alt={'eiffel'} css={cssIcon} />
      ) : (
        <img src={saharaInActive} alt={'eiffel'} css={cssIcon} />
      ),
  },
  // {
  //   name: 'Moscow to Berlin',
  //   value: 1816000,
  //   renderIcon: ({ isActive }) => <KremlinIcon css={isActive ? cssFillActivePaths : {}} />,
  // },
  {
    name: 'Tour De France',
    value: 3357000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={cyclingActive} alt={'cycling'} css={cssIcon} />
      ) : (
        <img src={cyclingInActive} alt={'cycling'} css={cssIcon} />
      ),
  },
  // {
  //   name: 'Across USA',
  //   value: 4569000,
  //   renderIcon: ({ isActive }) => <LibertyIcon css={isActive ? cssFillActivePaths : {}} />,
  // },
  {
    name: 'NYC to LA',
    value: 4492000,
    renderIcon: ({ isActive }) => <LibertyIcon css={isActive ? cssFillActivePaths : {}} />,
  },
  {
    name: 'Across south america',
    value: 9329000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={globeSUSAInActive} alt={''} css={cssIcon} />
      ) : (
        <img src={globeSUSAInActive} alt={''} css={cssIcon} />
      ),
  },
  {
    name: 'Great wall of china',
    value: 21197000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={chinaWallActive} alt={''} css={cssIcon} />
      ) : (
        <img src={chinaWallInActive} alt={''} css={cssIcon} />
      ),
  },
  {
    name: 'Around the world',
    value: 40075000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={globeActive} alt={'globe'} css={cssIcon} />
      ) : (
        <img src={globeInActive} alt={'globe'} css={cssIcon} />
      ),
  },
  {
    name: 'Moon',
    value: 384400000,
    renderIcon: ({ isActive }) =>
      isActive ? (
        <img src={moonActive} alt={'globe'} css={cssIcon} />
      ) : (
        <img src={moonInActive} alt={'globe'} css={cssIcon} />
      ),
  },
]

export default ranks
